import React, { useState } from "react";
import { connect } from "react-redux";
import "react-phone-number-input/style.css";
import "../../styles/businessBackofficeStyles.scss";

import BusinessUsers from "../Business/BusinessUsers";
import BusinessGroups from "../Business/BusinessGroups";
import "../Employees/Employees";
import { selectAuthState } from "../../../store/selectors/authSelectors";

function UsersSection(props) {
  const { initialTab = "SYSTEM_USERS", embedded = false } = props;
  const [tab, setTab] = useState(initialTab);
  
  return (
    <div className={`w-full ${embedded ? '' : 'min-h-screen'} bg-gradient-to-br from-slate-50/50 via-white to-blue-50/30 dark:from-slate-900 dark:via-slate-800 dark:to-slate-900`}>
      {/* Header Section - Solo mostrar si no está embebido */}
      {!embedded && (
        <div className="bg-white/70 dark:bg-slate-800/70 backdrop-blur-sm border-b border-slate-200/50 dark:border-slate-700/50 sticky top-0 z-10">
          <div className="w-full px-6 py-6">
            <div className="space-y-4">
              <div className="flex items-center space-x-3">
                <div className="p-2 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-xl shadow-sm">
                  <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.25 2.25 0 11-4.5 0 2.25 2.25 0 014.5 0z" />
                  </svg>
                </div>
                <div>
                  <h1 className="text-2xl font-semibold text-slate-900 dark:text-slate-100 tracking-tight">
                    Gestión de Usuarios
                  </h1>
                  <p className="text-sm text-slate-600 dark:text-slate-400 mt-1">
                    Administra usuarios y grupos del sistema
                  </p>
                </div>
              </div>
              
              {/* Clean Tab Navigation */}
              <div className="flex items-center space-x-1 bg-slate-100/80 dark:bg-slate-700/80 p-1 rounded-xl backdrop-blur-sm border border-slate-200/50 dark:border-slate-600/50 shadow-sm">
                <button
                  className={`flex-1 px-6 py-3 text-sm font-medium rounded transition-all duration-200 ${
                    tab === "SYSTEM_USERS"
                      ? "bg-white dark:bg-slate-600 text-slate-900 dark:text-slate-100 shadow-sm border border-slate-200/50 dark:border-slate-500/50"
                      : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-white/50 dark:hover:bg-slate-600/50"
                  }`}
                  onClick={() => setTab("SYSTEM_USERS")}
                >
                  <div className="flex items-center justify-center space-x-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                    </svg>
                    <span>Usuarios del Sistema</span>
                  </div>
                </button>
                
                <button
                  className={`flex-1 px-6 py-3 text-sm font-medium rounded transition-all duration-200 ${
                    tab === "SYSTEM_GROUPS"
                      ? "bg-white dark:bg-slate-600 text-slate-900 dark:text-slate-100 shadow-sm border border-slate-200/50 dark:border-slate-500/50"
                      : "text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-slate-100 hover:bg-white/50 dark:hover:bg-slate-600/50"
                  }`}
                  onClick={() => setTab("SYSTEM_GROUPS")}
                >
                  <div className="flex items-center justify-center space-x-2">
                    <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                    </svg>
                    <span>Grupos del Sistema</span>
                  </div>
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Content Section */}
      <div className={`w-full ${embedded ? 'p-0' : 'px-6 py-6'}`}>
        <div className={`${embedded ? '' : 'bg-white/70 dark:bg-slate-800/70 backdrop-blur-sm rounded-2xl border border-slate-200/50 dark:border-slate-700/50 shadow-sm overflow-hidden'} w-full`}>
          {tab === "SYSTEM_USERS" && <BusinessUsers {...props} />}
          {tab === "SYSTEM_GROUPS" && <BusinessGroups {...props} />}
        </div>
      </div>
    </div>
  );
}

export default connect(selectAuthState)(UsersSection);
